import React from 'react';
import { useParams } from 'react-router-dom';
import { Dialogs, useDialogManager } from '@/modules/Dialogs';

export default function useContributionDialog(
  isOpen,
  { donationId, onClose, onSuccess, preSelectedDonorId },
) {
  const { campaignId } = useParams();
  const { openDialog } = useDialogManager();

  React.useEffect(() => {
    if (isOpen) {
      openDialog(Dialogs.DONATION_FORM, {
        campaignId,
        donationId,
        onClose,
        onSuccess,
        preSelectedDonorId,
      });
    }
  }, [isOpen]);
}
